import { LocalStorage } from 'helpers/localStorage';

export const isAuroraCrystalActiveLS = new LocalStorage<string, boolean>(
  'is-aurora-crystal-active',
  false
);
